export interface StaticFeatureFlagConfig {
  enableVacancyInvite: boolean;
  enableJobseekerSearch: boolean;
  enableDarkMode: boolean;
  enableAdvancedFilters: boolean;
}

export type StaticFeatureFlagKey = keyof StaticFeatureFlagConfig;

export const DEFAULT_STATIC_FEATURE_FLAGS: StaticFeatureFlagConfig = {
  enableVacancyInvite: false,
  enableJobseekerSearch: false,
  enableDarkMode: false,
  enableAdvancedFilters: false,
};
